import React from "react";
import { Link } from "react-router-dom";
import "./styles.less";

// import { useTranslation } from "react-i18next";

export const CommonBlogTag = (props) => {
  const tags = [
    { tag: "统一用户管理", link: "" },
    { tag: "统一认证系统", link: "" },
    { tag: "系统集成方案", link: "" },
    { tag: "统一身份认证平台", link: "" },
    { tag: "统一身份认证系统", link: "" },
    { tag: "双因素认证", link: "" },
    { tag: "可信身份认证平台", link: "" },
    { tag: "sso 实现方案", link: "" },
    { tag: "数字身份认证", link: "" },
    { tag: "数字身份", link: "" },
    { tag: "统一身份管理系统", link: "" },
    { tag: "统一身份认证技术", link: "" },
    { tag: "统一身份认证对接", link: "" },
    { tag: "统一身份认证公司", link: "" },
    { tag: "统一门户解决方案", link: "" },
    { tag: "统一账号管理系统", link: "" },
    { tag: "多系统统一登录", link: "" },
    { tag: "oauth 单点登录", link: "" },
    { tag: "多平台账号管理", link: "" },
    { tag: "token 单点登录", link: "" },
    { tag: "oauth2 单点登录", link: "" },
    { tag: "跨域单点登录", link: "" },
    { tag: "多系统单点登录", link: "" },
    { tag: "oa 单点登录", link: "" },
    { tag: "单点登录跨平台", link: "" },
    { tag: "单点登录如何做", link: "" },
    { tag: "单点登录解决方案", link: "" },
    { tag: "如何实现单点登录", link: "" },
    { tag: "单点登录原理", link: "" },
    { tag: "单点登录系统", link: "" },
    { tag: "单点登录系统整合", link: "" },
    { tag: "sso 单点登录方案", link: "" },
    { tag: "网络零信任", link: "" },
    { tag: "零信任框架", link: "" },
    { tag: "零信任厂商", link: "" },
    { tag: "公司零信任", link: "" },
    { tag: "多因素认证", link: "" },
    { tag: "可信身份认证", link: "" },
    { tag: "零信任网络安全", link: "" },
    { tag: "零信任是什么", link: "" },
    { tag: "多因素认证方案", link: "" },
    { tag: "多因素身份认证", link: "" },
    { tag: "多因素身份系统", link: "" },
    { tag: "多因素认证因素", link: "" },
    { tag: "多因素认证软件", link: "" },
    { tag: "网站可信身份认证", link: "" },
  ];
  return (
    <>
      <div className="blog-tag">
        {tags.map((item) => (
          <Link className="blog-tag-item" to="/blog">
            {item.tag}
          </Link>
        ))}
      </div>
    </>
  );
};
